/******************************************************************************
*
* Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
*
* Unauthorized copying of the code in this file, completely or partially,
* via any medium is strictly prohibited.
*
* Proprietary and Confidential.
*
* Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
*
*****************************************************************************/

import React from "react";
import { string } from "../constant/string";

/**
 * This is a copyright file 
 * 
 * @returns JSX for copyright 
 */
const Copyright = () => {
  return (
    <div className="copyright">
      {string.COPYRIGHT_2016} {new Date().getFullYear()}{" "}
      {string.SERVICEACTIVATOR_INC_ALL_RIGHTS_RESERVED}
    </div>
  );
};

export default Copyright;
